import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import './styles/main.css';
// import './styles/variables.less';
import { store } from './store';
import { ConfigProvider } from 'antd';
import { getEnvBearerToken, GINJA_APP_SERVICE_API_BASE, GINJA_PLATFORM_API_BASE, SSO_COOKIE_SENTINEL, GINJA_LOCAL_STORAGE_KEYS } from "./services/ginjaAuth";

// Global fetch auth injection for local/dev.
// This repo still has many direct fetch() calls; this keeps them working with env-based bearer tokens.
(() => {
  if (typeof window === "undefined" || typeof window.fetch !== "function") return;

  const originalFetch = window.fetch.bind(window);

  function bearerTokenForRequests() {
    const token = localStorage.getItem(GINJA_LOCAL_STORAGE_KEYS.token);
    if (token && token !== SSO_COOKIE_SENTINEL) return token;

    const authToken = localStorage.getItem(GINJA_LOCAL_STORAGE_KEYS.authToken);
    if (authToken && authToken !== SSO_COOKIE_SENTINEL) return authToken;

    return getEnvBearerToken();
  }

  function shouldInject(url) {
    if (!url) return false;
    try {
      const u = new URL(url, window.location.origin);
      // Only inject for Ginja APIs (platform + product).
      return (
        u.href.startsWith(GINJA_PLATFORM_API_BASE) ||
        u.href.startsWith(GINJA_APP_SERVICE_API_BASE) ||
        u.hostname.endsWith(".ginja.ai")
      );
    } catch {
      return false;
    }
  }

  window.fetch = (input, init) => {
    const url = typeof input === "string" ? input : input?.url;
    const nextInit = init ? { ...init } : {};

    if (shouldInject(url)) {
      const headers = new Headers(nextInit.headers || (typeof input !== "string" ? input?.headers : undefined) || {});
      if (!headers.has("Authorization")) {
        const token = bearerTokenForRequests();
        if (token) headers.set("Authorization", `Bearer ${token}`);
      }
      // Ensure cookies can flow when needed.
      if (!nextInit.credentials) nextInit.credentials = "include";
      nextInit.headers = headers;
    }

    return originalFetch(input, nextInit);
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#3ab44d',
            colorSecondary: '#f87d4e',
          },
        }}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </Provider>,
);
